import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=6ab23bc5&scoped=true&"
var script = {}
import style0 from "./Documentation.vue?vue&type=style&index=0&id=6ab23bc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab23bc5",
  null
  
)

export default component.exports